const actionTypeIdentifier = "B7DD7E5F-82F5-4F0B-9F61-2883E8CF6884";

export const getArticleUploadTypes = `GET-ARTICLE-UPLOAD-TYOES${actionTypeIdentifier}`;
export const setArticleUploadError = `SET-ARTICLE-UPLOAD-ERROR${actionTypeIdentifier}`;

export const ArticleUploadModel = {
    articleUploadTypeId: 0,
    files: []
}